// extracted by mini-css-extract-plugin
export default {"info":"delete-modal_info__BJJ2Y","text":"delete-modal_text__Ukqol","source":"delete-modal_source__Txf8q","button":"delete-modal_button__kARrv"};